export const BASE_URL = 'https://novyi-familnyi.ru/';
export const IN_STOCK = 'https://schema.org/InStock';
export const SOLD_OUT = 'https://schema.org/SoldOut';
